

export class TariffPlanOutputWithStatus implements ITariffPlanOutputWithStatus {
    /** The auto-generated id of the tariff plan  master */
    tariff_plan_id!: number;
    /** The auto-generated id of the company details master */
    company_details_id!: number;
    /** The company name with 255 character limit */
    company_name!: string;
    /** The auto-generated id of the state  master */
    state_id!: number;
    /** The provider name with 255 character limit */
    provider_name!: string;
    /** The tariff plan with 255 character limit */
    tariff_plan!: string;
    /** The tariff plan validity days */
    validity_days!: number;
    /** The tariff plan data usage */
    data_usage_mb!: number;
    /** Manage tariff plan of fuel type. 0 For De-active, 1 For Active */
    status!: number;
    /** The state name with 255 character limit */
    state_name!: string;
    /** The auto-generated id of the country  master */
    country_id!: number;
    /** The country name with 255 character limit */
    country_name!: string;

    constructor(data?: ITariffPlanOutputWithStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tariff_plan_id = _data["tariff_plan_id"];
            this.company_details_id = _data["company_details_id"];
            this.company_name = _data["company_name"];
            this.state_id = _data["state_id"];
            this.provider_name = _data["provider_name"];
            this.tariff_plan = _data["tariff_plan"];
            this.validity_days = _data["validity_days"];
            this.data_usage_mb = _data["data_usage_mb"];
            this.status = _data["status"];
            this.state_name = _data["state_name"];
            this.country_id = _data["country_id"];
            this.country_name = _data["country_name"];
        }
    }

    static fromJS(data: any): TariffPlanOutputWithStatus {
        data = typeof data === 'object' ? data : {};
        let result = new TariffPlanOutputWithStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tariff_plan_id"] = this.tariff_plan_id;
        data["company_details_id"] = this.company_details_id;
        data["company_name"] = this.company_name;
        data["state_id"] = this.state_id;
        data["provider_name"] = this.provider_name;
        data["tariff_plan"] = this.tariff_plan;
        data["validity_days"] = this.validity_days;
        data["data_usage_mb"] = this.data_usage_mb;
        data["status"] = this.status;
        data["state_name"] = this.state_name;
        data["country_id"] = this.country_id;
        data["country_name"] = this.country_name;
        return data; 
    }
}

export interface ITariffPlanOutputWithStatus {
    /** The auto-generated id of the tariff plan  master */
    tariff_plan_id: number;
    /** The auto-generated id of the company details master */
    company_details_id: number;
    /** The company name with 255 character limit */
    company_name: string;
    /** The auto-generated id of the state  master */
    state_id: number;
    /** The provider name with 255 character limit */
    provider_name: string;
    /** The tariff plan with 255 character limit */
    tariff_plan: string;
    /** The tariff plan validity days */
    validity_days: number;
    /** The tariff plan data usage */
    data_usage_mb: number;
    /** Manage tariff plan of fuel type. 0 For De-active, 1 For Active */
    status: number;
    /** The state name with 255 character limit */
    state_name: string;
    /** The auto-generated id of the country  master */
    country_id: number;
    /** The country name with 255 character limit */
    country_name: string;
}

